import { TemplateAttributeModel } from '../../../model/templateattributemodel.model';
import { ApoQueryable } from '../../apo/models/apoRecord.model';
import { NoticeConditionModel } from '../../apo/models/NoticeConditionModel.model';

export class AddressModel implements ApoQueryable {

    /// <remarks/>
    addressLine1 = '';

    /// <remarks/>
    addressLine2 = '';

    /// <remarks/>
    addressLine3: string;

    /// <remarks/>
    addressType: string;

    /// <remarks/>
    //auditModel: SimpleAuditModel;

    /// <remarks/>
    city: string;

    /// <remarks/>
    //contactAddressPK: ContactAddressPKModel;

    /// <remarks/>
    countryCode: string;

    /// <remarks/>
    effectiveDate: Date;

    /// <remarks/>
    entityID: number;

    /// <remarks/>
    entityType: string;

    /// <remarks/>
    expirationDate: Date;

    /// <remarks/>
    fax: string;

    /// <remarks/>
    faxCountryCode: string;

    /// <remarks/>
    fullAddress: string;

    /// <remarks/>
    houseNumberEnd: number;

    /// <remarks/>
    houseNumberStart: number;

    /// <remarks/>
    orderBy: string;

    /// <remarks/>
    phone: string;

    /// <remarks/>
    phoneCountryCode: string;

    /// <remarks/>
    recipient: string;

    /// <remarks/>
    state: string;

    /// <remarks/>
    streetDirection = '';

    /// <remarks/>
    streetName = '';

    /// <remarks/>
    streetPrefix = '';

    /// <remarks/>
    streetSuffix = '';

    /// <remarks/>
    streetSuffixDirection: string;

    /// <remarks/>
    unitEnd: string;

    /// <remarks/>
    unitStart: string;

    /// <remarks/>
    unitType: string;

    /// <remarks/>
    zip: string;

    /// <remarks/>
    levelPrefix: string;

    /// <remarks/>
    levelNumberStart: string;

    /// <remarks/>
    levelNumberEnd: string;

    /// <remarks/>
    houseNumberAlphaStart: string;

    /// <remarks/>
    houseNumberAlphaEnd: string;

    /// <remarks/>
    replaceAddressID: number;

    /// <remarks/>
    validateFlag: string;

    addressDescription: string;

    /// <remarks/>
    addressStatus: string;

    /// <remarks/>
    addressTypeFlag: string;

    /// <remarks/>
    auditDate: Date;

    /// <remarks/>
    auditID: string;

    /// <remarks/>
    auditStatus: string;

    /// <remarks/>
    //public CapIDModel capID

    /// <remarks/>
    country: string;

    /// <remarks/>
    county: string;

    /// <remarks/>
    eventID: string;

    /// <remarks/>
    houseFractionEnd: string;

    /// <remarks/>
    houseFractionStart: string;

    /// <remarks/>
    inspectionDistrict: string;

    /// <remarks/>
    inspectionDistrictPrefix: string;

    /// <remarks/>
    neighborhoodPrefix: string;

    /// <remarks/>
    neighborhood: string;

    /// <remarks/>
    primaryFlag: string;

    /// <remarks/>
    secondaryRoad: string;

    /// <remarks/>
    serviceProviderCode: string;

    /// <remarks/>
    sourceFlag: string;

    /// <remarks/>
    sourceNumber: number;

    /// <remarks/>
    streetSuffixdirection: string;

    /// <remarks/>
    UID: string;

    /// <remarks/>
    resState: string;

    /// <remarks/>
    addressId: number;

    /// <remarks/>
    refAddressId: number;

    resCountryCode: string;
    /// <remarks/>

    resStreetDirection: string;
    /// <remarks/>
    resStreetSuffixdirection: string;

    /// <remarks/>
    resUnitType: string;

    /// <remarks/>
    resStreetSuffix: string;

    templates: Array<TemplateAttributeModel>;

    hightestCondition: NoticeConditionModel;

    noticeConditions: NoticeConditionModel[];
}
